import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Card, Grid, FormHelperText } from '@mui/material';
import Page from 'src/components/Page';
import palette from 'src/theme/palette';

export default function Category() {
  return (
    <Page title={`Category | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3, mt: 2, pb: 2, pl: 1 }}>
          <Typography
            sx={{
              fontSize: { xs: 20, md: 25 },
              fontFamily: 'poppinsSemiBold',
              color: palette.primary.titledark
            }}
          >
            Select Featured Category
          </Typography>
        </Box>

        

      </Box>
    </Page>
  );
}